import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { StockModelListStyled } from '../StockModelListStyled';
import { rem } from 'polished';

export const StockModelListStyledDS = styled(StockModelListStyled)`
    .last-item-wrapper {
        .last-item-banner-container-text h3 {
            font-size: ${({ theme }) => theme.fontSizes.h5};
        }

        .last-item-banner-container-button button {
            background: ${({ theme }) => theme.colors.black1};
            font-size: ${({ theme }) => theme.fontSizes.h5};
            border-radius: ${rem(24)};
            text-transform: unset;

            &:hover,
            &:focus-visible {
                background: ${({ theme }) => theme.colors.primary};
            }
        }
    }

    @media (min-width: ${breakpoints.xs}px) {
        padding: 0 ${rem(20)};
    }
`;
